import styled from 'styled-components';

const PrintingCard = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: space-around;
  border: solid thin black;
`;

export default PrintingCard;



// WEBPACK FOOTER //
// ./src/common/modules/printing/styles/PrintingCard.js